export default "__VITE_ASSET__BbYSRWcu__"